import React from 'react';
import { makeStyles } from '@material-ui/core';
import SamplePhoto, { SAMPLE_PHOTO_TYPE_ENUM } from './SamplePhoto';

const useSamplePhotosStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    marginBottom: '20px',
    width: '100%',
  },
}));

interface ISamplePhotos {
  wrongSamples: string[];
  correctSamples: string[];
}

const SamplePhotos: React.FC<ISamplePhotos> = ({ wrongSamples, correctSamples }) => {
  const classes = useSamplePhotosStyles();
  const numberOfSamples = wrongSamples.length + correctSamples.length;

  const renderWrongSamples = () =>
    wrongSamples.map((url, index) => (
      <SamplePhoto
        key={`wrong-sample-${index}`}
        url={url}
        type={SAMPLE_PHOTO_TYPE_ENUM.WRONG}
        numberOfSamples={numberOfSamples}
      />
    ));

  const renderCorrectSamples = () =>
    correctSamples.map((url, index) => (
      <SamplePhoto
        key={`correct-sample-${index}`}
        url={url}
        type={SAMPLE_PHOTO_TYPE_ENUM.CORRECT}
        numberOfSamples={numberOfSamples}
      />
    ));

  return (
    <div className={classes.root}>
      {renderWrongSamples()}
      {renderCorrectSamples()}
    </div>
  );
};

export default SamplePhotos;
